import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Kerib lehe ülespoole iga marsruudi vahetuse korral.
 * Vajalik, et Classes lehelt teisele lehele navigeerides ei jääks
 * eelmise lehe scroll-positsioon alles.
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        const root = document.getElementById('root');
        if (root) root.scrollTop = 0;
    }, [pathname]);

    return null;
}
